export default () => (<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24">
    <g fill="none" fillRule="evenodd">
        <path fillRule="nonzero" d="M3 2h19v19H3z"/>
        <g stroke="#242424">
            <path d="M9.5 6.3V1h13v17h-7.6"/>
            <path d="M1.5 6h13v17h-13z"/>
        </g>
        <path fillRule="nonzero" stroke="#242424" d="M12 12l-5.333 5L4 14.5"/>
    </g>
</svg>)
